module.exports = {"653225100":"策勒镇","653225101":"固拉合玛镇","653225200":"策勒乡","653225202":"达玛沟乡","653225203":"恰哈乡","653225204":"乌鲁克萨依乡","653225205":"奴尔乡","653225206":"博斯坦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653225.json
// module id = 3264
// module chunks = 0